import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './notfound.css';

const NotFound = () => {
  return (
    <div className="not-found-container">
      <Helmet>
        <title>Sidan hittades inte | Cycle Solutions</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <h1>404 - Page Not Found</h1>
      <p>Sorry, the page you are looking for does not exist.</p>
      <Link to="/">Go back to homepage</Link>
    </div>
  );
};

export default NotFound;
